import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import {
	Accordion,
	FormGroup,
	FormControl,
	ControlLabel,
	Col,
	HelpBlock
} from 'react-bootstrap';
import IntlComponent from 'axway-react-intl';
import pluralize from 'pluralize';
import { CheckList, Panel } from 'axway-react-ui';

class ModelDesignEndpoints extends React.Component {
	constructor(props) {
		super(props);
		IntlComponent.init(this);

		this.onChange.bind(this);
		this.onCheckListChange = this.onCheckListChange.bind(this);
		this.actions = [ 'create', 'read', 'update', 'delete' ];
		this.onSingularChange = this.onSingularChange.bind(this);
		this.onPluralChange = this.onPluralChange.bind(this);
	}

	// update ModelDesign.jsx to update this the react way
	onChange(key, value) {
		const update = {};
		update[key] = value;
		this.props.updateModelDef(update);
	}

	onCheckListChange(update) {
		let actions = [];
		for (let i = 0; i < this.actions.length; i++) {
			if (this.actions[i] === 'delete' && update[i]) {
				actions = actions.concat([ 'delete', 'deleteAll' ]);
			} else if (update[i] === true) {
				actions.push(this.actions[i]);
			}
		}
		this.onChange('actions', actions);
	}

	onSingularChange(e) {
		this.onChange('singular', e.target.value);
	}

	onPluralChange(e) {
		this.onChange('plural', e.target.value);
	}

	render() {
		const actions = this.props.modelDef.actions || [];
		const createChecked = actions.indexOf('create') >= 0;
		const readChecked = actions.indexOf('read') >= 0;
		const updateChecked = actions.indexOf('update') >= 0;
		const deleteChecked = actions.indexOf('delete') >= 0;
		const actionChecked
			= createChecked || readChecked || updateChecked || deleteChecked;

		return (
			<div className="models-design-endpoints">
				<div className="ux-form-container clearfix">
					<Col sm={12}>
						<fieldset>
							<legend><div className="legend ux-type-size-two">{this.intl.formatMsg('Response key (optional)')}</div></legend>
						</fieldset>
					</Col>
					<Col sm={6}>
						<FormGroup controlId="singular">
							<ControlLabel>{`${this.intl.formatMsg('Singular')}:`}</ControlLabel>
							<FormControl
								id="singular"
								type="text"
								placeholder={this.intl.formatMsg('Override default')}
								onChange={this.onSingularChange}
								value={this.props.modelDef.singular || ''}
							/>
							<HelpBlock>
								{this.intl.formatMsg('The default value is')}: <b>{this.props.modelDef.name}</b>
							</HelpBlock>
						</FormGroup>
					</Col>
					<Col sm={6}>
						<FormGroup controlId="plural">
							<ControlLabel>{`${this.intl.formatMsg('Plural')}:`}</ControlLabel>
							<FormControl
								id="plural"
								type="text"
								placeholder={this.intl.formatMsg('Override default')}
								onChange={this.onPluralChange}
								value={this.props.modelDef.plural || ''}
							/>
							<HelpBlock>
								{this.intl.formatMsg('The default value is')}: <b>{pluralize(this.props.modelDef.name)}</b>
							</HelpBlock>
						</FormGroup>
					</Col>
				</div>
				<div className="ux-form-container">
					<Accordion id="panel">
						<Panel
							eventKey="1"
							hasIcon
							header={this.intl.formatMsg('Select methods to enable dynamic APIs for this model (optional)')}
							independent
							defaultExpanded={actionChecked}
						>
							<Col sm={12}>
								<fieldset>
									<CheckList onChange={this.onCheckListChange}>
										<CheckList.Item
											description={this.intl.formatMsg('Create one')}
											checked={createChecked}
										>
											{this.intl.formatMsg('Create methods')}
										</CheckList.Item>
										<CheckList.Item
											description={this.intl.formatMsg('Query, Find all, Count, Distinct')}
											checked={readChecked}
										>
											{this.intl.formatMsg('Retrieve methods')}
										</CheckList.Item>
										<CheckList.Item
											description={this.intl.formatMsg('Update')}
											checked={updateChecked}
										>
											{this.intl.formatMsg('Update methods')}
										</CheckList.Item>
										<CheckList.Item
											description={this.intl.formatMsg('Delete one, Delete all')}
											checked={deleteChecked}
										>
											{this.intl.formatMsg('Delete methods')}
										</CheckList.Item>
									</CheckList>
								</fieldset>
							</Col>
						</Panel>
					</Accordion>
				</div>
			</div>
		);
	}
}

ModelDesignEndpoints.propTypes = {
	modelDef: PropTypes.object.isRequired,
	updateModelDef: PropTypes.func.isRequired
};

export default injectIntl(ModelDesignEndpoints);
